import { Skeleton } from '@genial/components';
import { useMemo } from 'react';

import { TableContent, TableContentItemColumn } from '../../../components/TableContent';
import { dividendsHistoryTableHead } from '../constants';
import { getFlex } from '../utils';

export const DividendHistoryItemLoadingDesktop = () => {
  const skeletons = useMemo(
    () =>
      Array.from({ length: dividendsHistoryTableHead.length - 1 }, (_, i) => i).map((index) => (
        <TableContentItemColumn key={index.toString()} flex={getFlex(index)}>
          <Skeleton width={40 + Math.random() * 50 + '%'} height="inset.xs" borderRadius="sm" />
        </TableContentItemColumn>
      )),
    []
  );

  return (
    <TableContent direction="row" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      {skeletons}
    </TableContent>
  );
};
